import { TravelExploreTwoTone } from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { OrdiniRitiroContext } from "../../../context";
import { useForm } from "../../../hooks";

const Servizio = ({ mainForm, setMainForm,formautomatico, ServizioAutomatico }) => {
  const {
    state: { servizi },
    getServizibyRitiri,
  } = useContext(OrdiniRitiroContext);

  
  const { values: servizioPerWebForm, changeHandler } = useForm(
    {
      ServizioPerWeb: " ",
      Servizio: ServizioAutomatico || "",
    },
    []
  );

  useEffect(() => {
    if (ServizioAutomatico != null && ServizioAutomatico !== undefined && ServizioAutomatico.trim() !== "") {
      //non fare nulla, il servizio è già impostato automaticamente
    } else {
      getServizibyRitiri();
    }
    
  }, []);


  useEffect(() => {
    //13/08/2026 Greg: uso l'updater funzionale (come MerceADR/Contrassegno/Assicurazione) invece di
    //spreaddare "mainForm" (chiusura stale). Quando l'ordine arriva da un Preventivo, più sezioni
    //montano insieme e ognuna lancia il proprio effect one-shot su setMainForm nello stesso batch:
    //usando un valore semplice, l'ultima chiamata vince e le altre venivano perse.
    setMainForm(prev => ({
      ...prev,
      ServizioPerWeb: servizioPerWebForm.ServizioPerWeb ,
      Servizio: ServizioAutomatico
    }));
  }, [servizioPerWebForm, ServizioAutomatico, setMainForm]);

  return (
    <Card
      elevation={0}
      sx={{ background: (theme) => theme.palette.error.light + "25" }}
    >
      <CardHeader
        title={"Servizio"}
        subheader={""}
        subheaderTypographyProps={{
          fontWeight: "bold",
        }}
        titleTypographyProps={{
          fontWeight: "bold",
          fontSize: 18,
        }}
        avatar={<TravelExploreTwoTone />}
      />
      <CardContent>
        <Grid item container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            {ServizioAutomatico && ServizioAutomatico.trim() !== "" ? (
              <TextField
                label="Servizio"
                fullWidth
                value={ServizioAutomatico}
                InputProps={{ readOnly: true }}
              />
            ) : (
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Servizio</InputLabel>
       
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                fullWidth
                size="small"
                value={servizioPerWebForm.ServizioPerWeb || ""}
                label="Servizio"
                onChange={(e) => {
                  const nextValue = e.target.value;
                  changeHandler("ServizioPerWeb", nextValue);
                  
                }}
                >
                <MenuItem value={" "}>Scegli il servizio</MenuItem>
                
                {servizi? (
                    servizi.map((servizio, i) => (
                    <MenuItem key={i} value={servizio.codice}>
                      {servizio.descrizione}
                    </MenuItem>
                    
                
                ))):(<></>)}
              </Select>

            </FormControl>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Servizio;
